<template>
  <hr style="visibility: hidden;">
  <div
    v-if="showSpace"
    :id="inlineMessageHtmlId"
    class="w-100 mx-auto px-3 d-flex flex-column justify-content-between gap-2"
  ></div>
</template>

<script setup lang="ts">
import { computed, onBeforeMount, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { cioanalytics } from "@/apps/credit-line/services/customerio.service";
import { AuthenticationHelper } from "@/apps/credit-line/helpers/authentication.helper";

const deviceTag = AuthenticationHelper.getDeviceTag();
const router = useRouter();
const route = useRoute();
const space = (route.query?.space as string);
const showSpace = computed(() => {
    if (!deviceTag) {
       return false;
    }
    if (!space) {
       return false;
    }
  return true;
});

const inlineMessageHtmlId = computed(() => {
    if (!space) {
       return null;
    }
  return 'promotion-inline-container-'+space;
});

onMounted(() => {
   if (showSpace) {
    cioanalytics.identify(deviceTag.value);
    cioanalytics.track("PROMOTION_INLINE_SCREEN",
                      {space: space}
    );
    cioanalytics.track("PROMOTION_INLINE_SCREEN_"+space);
    }
});

</script>
